import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import CheckoutForm from './CheckoutForm'; // Your custom checkout form component

const StripeContainer = ({invoicedata}) => {
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY, {
                      stripeAccount: invoicedata.stripe_acc_id, // Replace with the connected account ID
                    });
    const options = {
    // pass the client secret from the previous step
    clientSecret: invoicedata.clientSecret,
    // Fully customizable with the Appearance API
    appearance: {/*...*/},
  };
    return (
      <>
      <h5 style={{  }}>Add Card</h5>
        <Elements stripe={stripePromise} options={options} >
            <CheckoutForm invoicedata={invoicedata} />
        </Elements>
        </>
    );
};

export default StripeContainer;
